// extracted by mini-css-extract-plugin
module.exports = {"wrap":"confirm-message_wrap_2OjxN","icon":"confirm-message_icon_3F_Nk"};